module.exports = __webpack_public_path__ + "img/glasses-4.8e59bd5d.svg";